import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
interface FracturedHaloProps {
  size?: number;
  color?: string;
  segments?: number;
  className?: string;
  animate?: boolean;
  opacity?: number;
  vortexAnimation?: boolean;
}
export const FracturedHalo: React.FC<FracturedHaloProps> = ({
  size = 300,
  color = '#EAF6FF',
  segments = 8,
  className = '',
  animate = true,
  opacity = 0.5,
  vortexAnimation = false
}) => {
  const generateSegmentPath = (index: number, total: number, radius: number, gap: number = 0.15) => {
    const anglePerSegment = Math.PI * 2 / total;
    const startAngle = index * anglePerSegment;
    const endAngle = startAngle + anglePerSegment * (1 - gap);
    const startX = radius * Math.cos(startAngle);
    const startY = radius * Math.sin(startAngle);
    const endX = radius * Math.cos(endAngle);
    const endY = radius * Math.sin(endAngle);
    const largeArcFlag = 0;
    return `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
  };
  const vortexVariants = {
    initial: {
      pathLength: 0,
      opacity: 0,
      scale: 0.7
    },
    draw: {
      pathLength: 1,
      opacity: opacity,
      scale: 1,
      transition: {
        pathLength: {
          duration: 2.5,
          ease: 'easeInOut'
        },
        opacity: {
          duration: 0.8
        },
        scale: {
          duration: 2.5,
          ease: 'easeOut'
        }
      }
    },
    hold: {
      pathLength: 1,
      opacity: opacity,
      scale: 1,
      transition: {
        duration: 1.5
      }
    },
    implode: {
      scale: 0,
      opacity: 0,
      rotate: 90,
      transition: {
        duration: 1.2,
        ease: [0.6, 0.01, 0.05, 0.95]
      }
    }
  };
  const standardVariants = {
    initial: {
      opacity: 0,
      pathLength: 0
    },
    animate: {
      opacity: [opacity * 0.5, opacity, opacity * 0.8],
      pathLength: 1,
      rotate: [0, 5, 0]
    }
  };
  return <motion.svg width={size} height={size} viewBox={`-${size / 2} -${size / 2} ${size} ${size}`} className={className} initial={{
    rotate: 0
  }} animate={vortexAnimation ? {
    rotate: 360
  } : {}} transition={vortexAnimation ? {
    rotate: {
      duration: 12,
      repeat: Infinity,
      ease: 'linear'
    }
  } : {}} data-id="element-246">
      <g data-id="element-247">
        {Array.from({
        length: segments
      }).map((_, index) => <motion.path key={index} d={generateSegmentPath(index, segments, size / 2 - 10)} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" variants={vortexAnimation ? vortexVariants : standardVariants} initial="initial" animate={vortexAnimation ? ['draw', 'hold', 'implode', 'initial'] : 'animate'} transition={vortexAnimation ? {
        times: [0, 0.4, 0.7, 1],
        duration: 8,
        delay: index * 0.08,
        repeat: Infinity,
        repeatDelay: 0.5
      } : {
        duration: 6,
        delay: index * 0.2,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-248" />)}
      </g>
    </motion.svg>;
};